import { render } from "./BaseButton.vue?vue&type=template&id=182a9aea&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=182a9aea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-182a9aea"

export default script